import { BlocksTextPassage } from 'blocks-nextjs/blocks-web-components/components/text-passage/text-passage';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTextPassage = createComponent({ react: React, tagName: 'cat-text-passage', elementClass: BlocksTextPassage });
